/**
 * Módulo: Eventos · Organizar (Club Milbrands — 6-sep-2026)
 *
 * IMPORTANTE — SIN UI ni route propia (mismo patrón que `mercado-datos`):
 * existe como **ítem contratable del plan**. Un plan lo incluye —o no— en
 * `modulosIncluidos`, eso se denormaliza a `empresas.modulosDisponibles`
 * (sincronizarModulosPlan), y desde ahí gatean:
 *
 *   · el server, al ORGANIZAR: `functions/club/autorizacionOrganizador.js`
 *     exige este módulo en el plan de la empresa operadora (el operador
 *     plataforma —staff de Milbrands— no tiene plan y no lo necesita);
 *   · el front, al CONECTAR Mercado Pago: `plataformas/mercado-pago` declara
 *     `moduloId: 'eventos-organizar'` y la card de Integraciones de la empresa
 *     (`EmpresaIntegraciones`) se prende por ese módulo (rail de cobro, ADR
 *     2026-09-05); el SERVER lo exige en las 4 puertas de conexión
 *     (`exigirModuloDePlataformaEnPlan`, `conexiones.js`), detrás del flag
 *     `feature.integraciones.gatePlan`.
 *
 * La SUPERFICIE del organizador (panel de eventos, tipos de entrada, check-in,
 * stats) vive en `/eventos` —ruta del módulo `eventos` (Asistir)— y se gatea
 * por acción de ESTE módulo en el catálogo (`puede('eventos-organizar',
 * 'gestionar-eventos')`, etc.). Por eso organizar PRESUPONE asistir: el plan
 * de un operador incluye los dos módulos.
 *
 * Por qué dos módulos y no dos funciones de uno: el plan da módulos, no
 * funciones; "esta empresa asiste pero no organiza" sólo se puede decir a
 * nivel de plan si organizar es un módulo aparte. ADR
 * `2026-09-06-eventos-asistir-y-organizar-son-dos-entitlements-de-plan`.
 *
 * Acceso: NUNCA se lee `empresa.plan` ni `empresaIds` desde acá ni desde
 * `eventos` (regla del ADR rector); la frontera de plan es el server.
 */
export default {
  id: 'eventos-organizar',
  nombre: 'Eventos · Organizar',
  descripcion: 'Organizar eventos del Club: crear y publicar eventos, entradas, check-in, stats, reembolsos y reseñas. Habilita conectar Mercado Pago.',
  icono: 'calendar',
  tipo: 'operativo',
  version: '0.1.0',
  milbrandsInterno: false,

  // Sin rutas ni menú: la superficie vive en `/eventos`.
  routes: [],
  menuItems: [],

  features: [],

  // Vacío a propósito: no se gatea por rol como módulo visible — se gatea por
  // plan (server) y por acción del catálogo (`eventos-organizar.*`).
  permisoModulos: [],

}
